import { apiClient, omrehBaseClient } from "./client";


const CustomFilter = (data) => {

  return omrehBaseClient.post('/BrokerGroup/CustomFilter',
 {
        "groupId": data.groupId,
        "brokerId": data.brokerId,
        "opration":data.opration,
        "from": data.from,
        "to": data.to,
        "orderBy": data.orderBy,
        "orderDescending": data.orderDescending,
        "pageNumber": data.pageNumber,
        "pageSize": data.pageSize
    }
  );
}

const GetOprationDropDown=()=>{
  return omrehBaseClient.get('StaticVariables/GetOperationDropDown');
}
const GetFlightFilter=(filterData)=>{
  return omrehBaseClient.post('Flight/GetFlightFilter',
      {
     'flightNo':filterData.flightNo,
    'brokerName': filterData.brokerName,
    'brokerID': filterData.brokerID,
    'from':filterData.from,
    'type': filterData.type,
    // 'fromTime': filterData.fromTime,
    'to': filterData.to,
    // 'toTime': filterData.toTime,
    'isconfirm':filterData.isConfirm,
    'paginationParam': {
      'orderBy': filterData.orderBy,
      'orderDescending': filterData.orderDescending,
      'pageNumber': filterData.pageNumber,
      'pageSize': filterData.pageSize
    }
  }
  )
}
const GetFlightGroupsAndPassengers=(flightId)=>{
return omrehBaseClient.get('Flight/GetFlightGroupsAndPassengers',
  {
params: {
    'flightId': flightId
  }
  } 
);
}
const ConfirmFlight=(data)=>{
 return omrehBaseClient.put('Flight/ConfirmFlight',
  {
    'flightId': data.flightId,
    'onTime': data.onTime,
    'time': data.time,
    'flightDate': data.flightDate,
    'offScheduleReason':data.offScheduleReason,
    'description':data.description
  }
)
}
const CancelForTripAndMembers=(data)=>{

return omrehBaseClient.put('Flight/CancelForFlightAndMembers',
   data
)
}
const AddTafvigFile=(attachmntFile)=>{
  const form = new FormData();
if(attachmntFile)
  form.append('FormFile', attachmntFile);
return omrehBaseClient.post('TblTafvig/Add',
   form,
  {
    params: {
      'SkipRow': '1'
    },
  }
)
}
const AddFlightFile=(attachmntFile)=>{
  const form = new FormData();
if(attachmntFile)
  form.append('FormFile', attachmntFile);
return omrehBaseClient.post('TblFlight/Add',
   form,
  {
    params: {
      'SkipRow': '1'
    },
  }
)
}
const GetDelay=(data)=>{
  return omrehBaseClient.post('Flight/GetDelay',
    {
    'to': data.dateto,
    'from': data.datefrom,
    'flightType':data.flightType,
    'flightNo':data.flightNo,
    'paginationParam': {
      'orderBy': data.orderBy,
      'orderDescending': data.orderDescending,
      'pageNumber': data.pageNumber,
      'pageSize': data.pageSize
    }
  },
  )
}
const GetFlightTypeDropDown=()=>{
  return omrehBaseClient.get('StaticVariables/GetFlightTypeDropDown');
}
const SyncFlightInfoFromTblFlight=()=>{
  return omrehBaseClient.put('Flight/SyncFlightInfoFromTblFlight','');
}
const GetOffScheduleReasonDropDown=()=>{
return omrehBaseClient.get('StaticVariables/GetOffScheduleReasonDropDown');
}
const GetFlightReportManifestById=(flightid)=>{
  return omrehBaseClient.get('/Flight/GetFlightReportManifestById',
    {
params: {
    'flightId': flightid
  }
    }   
  )
}
const GetFlightById=(flightid)=>{
return omrehBaseClient.get('/Flight/GetById',
    {
params: {
    'key': flightid
  }
    }   
  )
}
const GetFlightDelayFormByAirLineName=(data)=>{
  return omrehBaseClient.post('AirLineSLA/GetFlightDelayFormByAirLineName',
    {
  'airLineType': data.airLineType,
  'operation': data.operation,
  'flightType': data.flightType,
  'flightId':data.flightId
  },
  )
}

const CalculateFlightDelayCompensation=(flightid)=>{
  return omrehBaseClient.get('/AirLineSLA/CalculatePilgrimFlightDelayCompensation',
    {
params: {
    'flightId': flightid
  }
    }   
  )
}
const AddPassengerToFlight=(flightId,passengerId)=>{
  return omrehBaseClient.put(
  'Flight/AddPassengerToFlight',
  '',
  {
    params: {
      'flightId': flightId,
      'passengerId': passengerId
    }
  });
}
const GetFlightGuestsByFlightId=(flightid)=>{
return omrehBaseClient.get('/FlightGuest/GetFlightGuests',
    {
  params: {
      'flightId': flightid
    } 
    }   
  )
}
const AddGuestToFlight=(flightId,data)=>{
  return omrehBaseClient.post('/FlightGuest',
    {
      'flightId': flightId,
  'guestType': data.guestType,
  'name': data.name,
  'family': data.family,
  'fatherName': data.fatherName,
  'ssn':data.ssn,
  'passNO': data.passNO,
  'mBirthDate':data.mBirthDate
    }
  )
}
const EditGuestToFlight=(id,data)=>{
  return omrehBaseClient.put('/FlightGuest',
    {
  'guestType': data.guestType,
  'name': data.name,
  'family': data.family,
  'fatherName': data.fatherName,
  'ssn':data.ssn,
  'passNO': data.passNO,
  'mBirthDate':data.mBirthDate
    },
  {
    params: {
      'id': id
    }
}
  )
}
const deleteFlightGuest=(id)=>{
return omrehBaseClient.delete('/FlightGuest',{
  params: {
      'key': id
    } 
})
}
const brokerGroupApi = {
    CustomFilter,GetOprationDropDown,GetFlightFilter,GetFlightGroupsAndPassengers,ConfirmFlight,CancelForTripAndMembers,AddTafvigFile,AddFlightFile,
    GetFlightTypeDropDown,SyncFlightInfoFromTblFlight,GetDelay,GetOffScheduleReasonDropDown,GetFlightReportManifestById,GetFlightById,GetFlightDelayFormByAirLineName,
    CalculateFlightDelayCompensation,AddPassengerToFlight,GetFlightGuestsByFlightId,AddGuestToFlight,deleteFlightGuest,EditGuestToFlight
}

export default brokerGroupApi


